import { PROJECT_DOMAINS, type ProjectDomain } from '@mybusinessmate/schema';
import { DOMAIN_META } from '../../lib/project-display';
import { ChoiceTile } from '../ui/choice-tile';

/** Three square choices (Figma A05.1b "Domain"): Website, Marketing, Automation. */
export function DomainPicker({
  value,
  onChange,
  error,
}: {
  value: ProjectDomain;
  onChange: (value: ProjectDomain) => void;
  error?: string;
}) {
  return (
    <fieldset className="flex flex-col gap-(--mbm-space-2)">
      <legend className="flex w-full items-baseline justify-between text-label-medium text-text-primary">
        Domain
        <span className="text-body-xsmall text-text-tertiary">Decides which general chat and pod it uses</span>
      </legend>
      <div className="grid grid-cols-3 gap-(--mbm-space-3)">
        {PROJECT_DOMAINS.map((domain) => (
          <ChoiceTile
            key={domain}
            icon={DOMAIN_META[domain].icon}
            label={DOMAIN_META[domain].label}
            selected={domain === value}
            showCheck={false}
            onSelect={() => onChange(domain)}
          />
        ))}
      </div>
      {error ? <p className="text-body-xsmall text-feedback-error">{error}</p> : null}
    </fieldset>
  );
}
